import React, { useState, useEffect } from "react";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";
import { useDispatch, useSelector } from "react-redux";
import {
  setWordsMain,
  setWordInAnswer,
  setTitle,
} from "../../../redux/action/user";
import {
  setEditTitle,
  setEditWord,
  setEditWords
} from "../../../redux/action/Edit";
import { useHistory } from "react-router";
import ErrorModal from '../../Error Modal/ErrorModal'
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ControlledOpenSelect from "../../AddWord/SelectLanguage";

export default function Match(props) {
  const reduxState = useSelector(state => state.user)
  // State
  const dispatch = useDispatch();
  const EditState = useSelector((state) => state.Edit);

  const [filterWordQuestion, setFilterWordQuestion] = useState([]);
  const [filterWordAnswer, setFilterWordAnswer] = useState([]);
  const [questions, setQuestions] = useState([]); //Save Words for post to server
  const [answers, setAnswers] = useState([]);
  const [langAnswer, setLangAnswer] = useState("fa"); // true = en false= fa
  const [langQuestion, setLangQuestion] = useState("en");
  const [findAnswer, setFindAnswer] = useState([])
  const [createQuestion, setCreateQuestion] = useState([])
  const [errorModal, setErrorModal] = useState(false)
  const [erorText, setErrorText] = useState()
  const [meaning, setMeaning] = useState("")
  const [openSelectBox, setOpenSelectBox] = useState(false)
  const [selectid, setSelectId] = useState()
  const [titlef, setTitlef] = useState(
    EditState.edit && EditState.title ? EditState.title : ""
  );
  const handleChange = async (e, index1) => {
    const value = e.target.value;
    findAnswer[index1].word = value
    dispatch(setEditWord(findAnswer))
    setOpenSelectBox(false)
  };

  const FuncFindAnswer = async question => {
    let meanings = question[question.length - 1].meanings;
    let p = question[question.length - 1].priority;
    let id = question[question.length - 1].word_id;
    let mainWord = question[question.length - 1].word;
    let mean = meanings[0]
    if (meanings.length === 1) {
      let mean = meanings[0]
      findAnswer.push({ word: mean, priority: p, word_id: id, mainWord: mainWord })
    }
    if (meanings.length > 1) {
      findAnswer.push({ word: mean, meaning: meanings, priority: p, word_id: id, mainWord: mainWord })
    }
  }

  let clearSingleAnswer = document.querySelectorAll('.MuiChip-deleteIcon')

  for (let i = 0; i < clearSingleAnswer.length; i++) {

    clearSingleAnswer[i].addEventListener("click", async function () {
      let FilteredAnswer = findAnswer.filter(item => item.mainWord !== clearSingleAnswer[i].parentNode.childNodes[0].innerHTML)
      let FilteredQuestion = createQuestion.filter(item => item.word !== clearSingleAnswer[i].parentNode.childNodes[0].innerHTML)
      setCreateQuestion(FilteredQuestion)
      EditState.edit && dispatch(setEditWords(FilteredQuestion))
      setFindAnswer(FilteredAnswer)
      EditState.edit && dispatch(setEditWord(FilteredAnswer))
    });
  }

  const QuestionsHandler = async (e, value, o) => {
    console.log(o, "value")
    if (o === "clear") {
      EditState.edit && dispatch(setEditWords([]))
      setCreateQuestion([])
    }else {
      setQuestions(value);
      let data = value[value.length - 1]
      await o === "select-option" && createQuestion.push({ word: data.word, word_id: data._id, priority: createQuestion.length > 0 ? createQuestion[createQuestion.length - 1].priority + 1 : 1, meanings: data.meanings })
      let addUniqeId = document.querySelectorAll('.MuiAutocomplete-tag')
      await o === "select-option" && addUniqeId[value.length - 1].classList.add(data._id)
      if (o === "select-option") {
        await value.length > 0 ? FuncFindAnswer(createQuestion) : setFindAnswer([])
      }
      dispatch(setWordsMain(createQuestion));
      EditState.edit && dispatch(setEditWords(createQuestion))
      EditState.edit && dispatch(setEditWord(findAnswer))
      dispatch(setWordInAnswer(findAnswer));
    }
  };


  const handletitle = (e) => {
    EditState.edit && dispatch(setEditTitle(e.target.value));
    dispatch(setTitle(e.target.value));
    setTitlef(e.target.value);
  };


  const changeWords = (A, Q) => {
    setLangAnswer(A);
    setLangQuestion(Q);
    handleFilterWord(A, Q);
  };

  const handleFilterWord = (A, Q) => {
    setFilterWordQuestion(reduxState.WordList.filter((word) => word.language === Q));
    setFilterWordAnswer(reduxState.WordList.filter((word) => word.language === A));
  };

  useEffect(() => {
    setFilterWordQuestion(
      reduxState.WordList.filter((word) => word.language === langQuestion)
    );
  }, []);

  useEffect(() => {
    dispatch(setWordInAnswer(findAnswer))
  }, [findAnswer]);


  const arrayCreateEditMatch = [];
  const questionArrayEdite = [];
  var changeWord = EditState.edit && EditState.word ? EditState.word : [];
  var questionEdite = EditState.edit && EditState.words ? EditState.words : [];

  if (questionEdite?.length !== 0) {
    questionEdite.forEach((word) => {
      questionArrayEdite.push({
        word_id: word.word_id._id,
        word: word.word,
        priority: word.priority,
      });
    });
  }
  if (changeWord?.length !== 0) {
    changeWord?.forEach((item) =>
      arrayCreateEditMatch.push({
        word_id: item.word_id._id,
        word: item.word,
        priority: item.priority,
      })
    );
  }



  const FuncClearAllAnswer = document.querySelector(".MuiAutocomplete-clearIndicator");

  FuncClearAllAnswer?.addEventListener("click", function () {
    setFindAnswer([])
    EditState.edit && dispatch(setEditWords([]))
    EditState.edit && dispatch(setEditWord([]))
  });

  useEffect(() => {
    EditState.edit && EditState.words && EditState.words.map(async (item, index) => {
      createQuestion.push({ word: item.word, word_id: item.word_id._id, priority: createQuestion.length + 1, meanings: item.word_id.meanings })
      await FuncFindAnswer(createQuestion)
    })
    EditState.edit && EditState.word.forEach((item, index1) => { return findAnswer[index1].word = item.word })

  }, [EditState.edit])


  return (
    <>
      <div className="Match">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 title_of_questions">
              <TextField
                variant="filled"
                id="standard-basic "
                value={titlef}
                className="text_bold"
                label={<p>عنوان سوال</p>}
                onChange={handletitle}
              />
            </div>
            <div className="col-12">
              <div className="text-right">
                <span className="text_bold">
                  لیست کلمـات را به همراه جواب درست رو به روی هم قرار دهید.
                </span>
              </div>
            </div>
            <div className="col-12 col-lg-6"></div>
            <div className="col-12 col-lg-6 pt-4 ltr">
              <div className="row">
                <div className="col-6">
                  <div className="text-center mb_MatchAnswer">
                    <span>جواب</span>

                  </div>
                  <div className="d-flex flex-column align-items-center justify-content-center">
                    {findAnswer && findAnswer.map((item, index1) => {
                      return (
                        <>
                          {
                            item.meaning ?
                              <>
                                <div className="answer_box d-flex" onMouseLeave={() => setOpenSelectBox(false)}>
                                  {openSelectBox && selectid === index1 ?
                                    <div className="position-relative pointer">
                                      <div className="position-absolute mt-2">
                                        <ArrowDropDownIcon />
                                      </div>
                                      <select
                                        onChange={(e) => handleChange(e, index1)}
                                        name={index1}
                                        className="form-control select_style_match"
                                      >
                                        <option>انتخاب معنی</option>
                                        {item.meaning.map((item, index2) => {
                                          return (
                                            <>
                                              <option value={item}>{item}</option>
                                            </>
                                          )
                                        })}
                                      </select>
                                    </div>
                                    :
                                    <div onMouseEnter={() => { setOpenSelectBox(true); setSelectId(index1) }} className="position-relative pointer">
                                      <div className="position-absolute">
                                        <ArrowDropDownIcon />
                                      </div>
                                      <span className="select_style_match" onClick={() => setOpenSelectBox(true)}>
                                        {item.word}
                                      </span>
                                    </div>
                                  }
                                </div>

                              </>
                              :
                              <div className="answer_box">
                                {item.word}
                              </div>
                          }
                        </>
                      )
                    })
                    }

                  </div>


                </div>
                <div className=" col-6 ">
                  <div className="text-center mb-3">
                    <span>سوال</span>
                    <div
                      className={`d-flex justify-content-center align-items-center`}
                    >
                      <button
                        className={`btn ${langQuestion === "fa" ? "text_bold" : ""
                          }`}
                        onClick={() => changeWords("en", "fa")}
                      >
                        Fa
                      </button>
                      <span>|</span>
                      <button
                        onClick={() => changeWords("fa", "en")}
                        className={`btn ${langQuestion === "en" ? "text_bold" : ""
                          }`}
                      >
                        En
                      </button>
                    </div>
                  </div>
                  <div className="d-flex justify-content-center">
                    <Autocomplete
                      multiple
                      className=""
                      id="tags-standard"
                      filterSelectedOptions
                      defaultValue={
                        questionArrayEdite !== [] &&
                        questionArrayEdite?.map(
                          (item) => item
                        )
                      }
                      options={
                        filterWordQuestion &&
                        filterWordQuestion.map((option) => option)
                      }
                      onChange={(e, v, o) => QuestionsHandler(e, v, o)}
                      getOptionLabel={(option) => option.word}
                      getOptionDisabled={(options) =>
                        questions.length > 3 ? true : false
                      }
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="standard"
                          className="input_pad"
                          placeholder={
                            langQuestion === "fa"
                              ? "انتخاب سوال"
                              : "Chose question"
                          }
                        />
                      )}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ErrorModal isOpen={errorModal} close={setErrorModal} eror={setErrorText} />
    </>
  );
}


{/* <Autocomplete
                    multiple
                    autoComplete
                    className=""
                    id="tags-standard"
                    filterSelectedOptions
                    value={findAnswer ? findAnswer.map(item => item) : answers}
                    defaultValue={
                      arrayCreateEditMatch !== [] &&
                      arrayCreateEditMatch?.map((item) => item)
                    }
                    options={
                      filterWordAnswer &&
                      filterWordAnswer.map((option) => option)
                    }
                    onChange={(e, v) => AnswerHandler(e, v)}
                    getOptionLabel={(option) => option.word}
                    getOptionDisabled={(options) =>
                      answers.length > 3 ? true : false
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="standard"
                        className="input_pad"
                        placeholder={
                          langAnswer === "fa" ? "انتخاب جواب" : "Chose answer"
                        }
                        autoComplete="off"
                      />
                    )}
                  /> */}
{/* <div
                    className={`d-flex justify-content-center align-items-center`}
                  >
                    <button
                      className={`btn ${langAnswer === "fa" ? "text_bold" : ""
                        }`}
                      onClick={() => changeWords("fa", "en")}
                    >
                      Fa
                    </button>
                    <span>|</span>
                    <button
                      onClick={() => changeWords("en", "fa")}
                      className={`btn ${langAnswer === "en" ? "text_bold" : ""
                        }`}
                    >
                      En
                    </button>
                  </div> */}
{/* <Carts openflashCartModal={openflashCartModal} setSelectedWord={setSelectedWord} selectedWord={selectedWord} Words={wordList} /> */ }
{/* {
                                    answer &&
                                    answer.map((item, index) => {
                                        <div key={index} className="d-flex justify-content-center align-items-cnenter">
                                            <div className="add_box_answer mx-5">

                                            </div>
                                        </div>
                                    })
                                } */}
{/* {
                                    InputisOpen ?
                                        <div className="d-flex justify-content-center align-items-cnenter">
                                            <div className="add_box_answer mx-5">

                                            </div>
                                        </div>
                                        :
                                        <div onClick={() => setInputIsOpen(true)} className="d-flex justify-content-center align-items-cnenter">
                                            <div className="add_box_answer mx-5">
                                                < AddIcon className="text_gray" fontSize="large" />
                                            </div>
                                        </div>
                                } */}